import React from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const PageLayout = ({ title, children, rightSideElements, backLink, className, rightSideElementsClassName }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f0f4fc] min-h-full flex flex-col py-5 px-10">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {backLink && (
            <button
              onClick={() => navigate(backLink)}
              className="p-2 rounded-full hover:bg-gray-100 transition"
            >
              <IoArrowBackOutline className="w-7 cursor-pointer h-7 " />
            </button>
          )}
          <h1 className="text-3xl font-semibold">{title}</h1>
        </div>

        {rightSideElements && (
          <div className={`${rightSideElementsClassName} flex items-center gap-3`}>{rightSideElements}</div>
        )}
      </div>

      <main className={`flex-1 p-4 ${className}`}>{children}</main>
    </div>
  );
};

export default PageLayout;
